export default "__VITE_ASSET__BSvwaJ2p__"